<template>
  <header
    :style="{ height }"
    :class="[
      themeValue,
      {
        'border-b': border,
        'sticky top-0 left-0 right-0 z-30 min-w-1376px w-full': fixedValue
      },
    ]"
    class="flex items-center min-w-1280px px-16px bg-[--bg-wrapper]"
  >
    <template v-if="['left', 'all'].includes(visible)">
      <Logo class="mr-24px" />
      <!-- 导航 -->
      <NavList />
    </template>

    <div v-if="['right', 'all'].includes(visible)" class="flex-row items-center c-header-r">
      <!-- 热门币种 -->
      <HotCurrency />
      <!-- 用户入口 -->
      <client-only v-if="userStore.isLogin">
        <UserNav />
      </client-only>
      <Logout v-else />
      <!-- 根据下载图标微调样式 -->
      <Download class="mr16" :class="[userStore.isLogin ? 'ml16' : 'ml20']" />
      <Language class="h28" />
    </div>
  </header>
</template>
<script setup lang="ts">
import { defineProps, provide, ref, watch } from 'vue';
import { useUserStore } from '@/store/User';
import Logo from './Logo.vue';
import NavList from '../hk-components/NavList.vue';
// import NavList from './NavList.vue';
// import Logout from './Logout.vue';
// import UserNav from './UserNav.vue';
import Download from './Download.vue';
import Language from './Language.vue';
import HotCurrency from './HotCurrency/Index.vue';

const UserNav = defineAsyncComponent(() => import('./UserNav.vue'));
const Logout = defineAsyncComponent(() => import('./Logout.vue'));
const route = useRoute();

const props = defineProps({
  height: {
    type: String,
    default: '56px'
  },
  border: {
    type: Boolean,
    default: true
  },
  theme: {
    type: String,
    default: ''
  },
  fixed: {
    type: Boolean,
    default: true
  },
  visible: {
    type: String,
    default: 'all'
  }
});

const userStore = useUserStore();

type RouteMetaProps = {
  header: {
    theme: string;
    border: boolean;
    fixed: boolean;
  };
};

const fixedValue = computed(() => {
  return props.fixed || (route.meta.props as RouteMetaProps)?.header?.fixed;
});

const themeValue = computed(() => {
  return props.theme || (route.meta.props as RouteMetaProps)?.header?.theme || '';
});
provide('theme', themeValue);

</script>

<style lang="scss">
.el-popover.el-popper.c-header-popper {
  border-radius: 8px;
  margin-top: 4px !important;
  &.header-lang-popper {
    margin-top: 2px !important;
  }
  &.header-website-popper {
    margin-top: -1px !important;
  }
  &.header-download-popper, &.header-message-popper {
    margin-top: 0 !important;
  }
}
.layout-exchange {
  & > header {
    margin-bottom: 3px;
  }
}
.dark .layout-exchange {
  & > header {
    margin-bottom: 4px;
  }
}
</style>

<style lang="scss" scoped>
.c-header-r {
  margin-left: auto;
}

.icon-divider {
  width: 1px;
  height: 16px;
  margin: 0 24px;
  background-color: var(--text-5);
}
</style>
